import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

type DimmableAreaProps = { dimmed?: boolean };

export const DimmableArea = styled(Box, {
  shouldForwardProp: prop => prop !== 'dimmed',
})<DimmableAreaProps>(({ dimmed }) => ({
  opacity: dimmed ? 0.5 : 1,
  transition: 'opacity 150ms',
}));
